import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Divider } from '@mui/material';
import './converge-accordion.scss';
import { ReactNode, SyntheticEvent } from 'react';

export interface IConvergeAccordionProps {
  header: ReactNode;
  children: ReactNode;
  expanded?: boolean;
  id: string;
  onChange: (isExpanded: boolean, id: string) => void;
}

export const ConvergeAccordion = ({
  header,
  children,
  expanded,
  id,
  onChange,
}: IConvergeAccordionProps) => {
  const handleChange = (_event: SyntheticEvent, isExpanded: boolean) => {
    onChange(isExpanded, id);
  };

  return (
    <div className="converge-accordion" data-testid="converge-accordion">
      <Accordion
        id={id}
        expanded={expanded}
        onChange={handleChange}
        TransitionProps={{ unmountOnExit: true }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{ flexDirection: 'row-reverse' }}
        >
          {header}
        </AccordionSummary>
        <Divider />
        <AccordionDetails>{children}</AccordionDetails>
      </Accordion>
    </div>
  );
};
